export { AiTranscriptionConsentDialog } from '@/components/molecules/consent/AiTranscriptionConsentDialog';
